import "./tableHead.css"

const TableItem = (props) =>{
    const {item, count} = props;

    return (
        
            <table className="table">
                <tbody>
                  <tr>
                        <td>{item.name}</td>
                        <td>{item.wood*count}</td>
                        <td>{item.clay*count}</td>
                        <td>{item.iron*count}</td>
                        <td>{item.crop*count}</td>
                        <td>{item.all*count}</td>
                 </tr>
                </tbody>
            </table>
       
        
        
    )
}
export default TableItem